import { WarningAltFilled } from "@carbon/icons-react";
import i18next from "../../i18n";

type Props = {
  errors: any[];
  invalid: any[];
  /** Single award uses `tenders.errors.title`, joint uses `award.warning`. */
  warningTitle: string;
};

const box = (border: string, bg: string): React.CSSProperties => ({
  borderRadius: 8,
  padding: "1rem",
  border: `1px solid ${border}`,
  background: bg,
  display: "flex",
  gap: "0.75rem",
});

/**
 * Consultation/volume warnings + invalid-input errors below the comparison matrix.
 * Shared by the single and joint award panels.
 */
const AwardWarnings = ({ errors, invalid, warningTitle }: Props) => {
  if (errors.length === 0 && invalid.length === 0) return null;
  return (
    <div
      style={{
        marginTop: "1rem",
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
      }}
    >
      {errors.map((error) => (
        <div
          key={error.orderId}
          style={box(
            "var(--cds-support-warning, #f1c21b)",
            "var(--cds-notification-background-warning, #fdf6dd)"
          )}
        >
          <WarningAltFilled
            size={20}
            style={{
              color: "var(--cds-support-warning, #f1c21b)",
              flexShrink: 0,
            }}
          />
          <div>
            <h3
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                margin: 0,
                color: "var(--cds-text-primary, #161616)",
              }}
            >
              {warningTitle}
            </h3>
            <p
              style={{
                fontSize: "0.75rem",
                margin: "0.5rem 0 0",
                color: "var(--cds-text-secondary, #525252)",
              }}
            >
              {error.message}
            </p>
          </div>
        </div>
      ))}
      {invalid.map((error) => (
        <div
          key={error.id}
          style={box(
            "var(--cds-support-error, #da1e28)",
            "var(--cds-notification-background-error, #fff1f1)"
          )}
        >
          <WarningAltFilled
            size={20}
            style={{
              color: "var(--cds-support-error, #da1e28)",
              flexShrink: 0,
            }}
          />
          <div>
            <h3
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                margin: 0,
                color: "var(--cds-text-primary, #161616)",
              }}
            >
              {i18next.t("award.invalidInput")}
            </h3>
            <p
              style={{
                fontSize: "0.75rem",
                margin: "0.5rem 0 0",
                color: "var(--cds-text-secondary, #525252)",
              }}
            >
              {error.message}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AwardWarnings;
